"use client";

import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { locales, type Locale } from "@/i18n/config";

export function LocaleSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const next: Locale = locales.find((l) => l !== locale) ?? locales[0];

  function switchLocale() {
    document.cookie = `NEXT_LOCALE=${next};path=/;max-age=31536000`;
    startTransition(() => router.refresh());
  }

  return (
    <button
      type="button"
      onClick={switchLocale}
      disabled={isPending}
      className="h-7 rounded-md px-2 text-xs font-medium text-fg-dim hover:bg-panel-2 hover:text-fg uppercase tracking-wide"
    >
      {next}
    </button>
  );
}
